import { IsMobile } from 'app/app';
import { initializeCallback } from 'app/modules/journey/service/step.service';
import { AlertDanger } from 'app/shared/components/alert';
import FormModal from 'app/shared/components/pop-up/form-modal';
import { IRootState } from 'app/shared/reducers';
import { persistSubscriptionTokenFromUrl } from 'app/shared/util/method-util';
import React, { useContext, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useParams } from 'react-router';
import { Button } from 'reactstrap';
import { loading, RD, SRD, success } from 'srd';

import { CircularProgress, Backdrop } from '@material-ui/core';

export const Callback = () => {

  const isMobile = useContext(IsMobile);
  const { subscriptionNumber, callback } = useParams<{ subscriptionNumber: string, callback: string }>();
  // callback = confirmation, cancellation, failure


  const dispatch = useDispatch();
  const history = useHistory();

  const currentSubscription = useSelector((state: IRootState) => state.subscription.subscriptionNumber);
  const appStyleCreatedStore = useSelector((state: IRootState) => state.cms.appStyleCreated);
  const stepsConfigStore = useSelector((state: IRootState) => state.config.steps);

  const [onCallbackSRD, setCallbackSRD] = React.useState<RD<string, string>>(loading())
  const [formModal, setFormModal] = React.useState(false);
  const [messageModal, setMessageModal] = React.useState("");


  const closeForm = () => {
    setFormModal(false);
    history.replace('/' + subscriptionNumber);
  }

  useEffect(() => {
    if (subscriptionNumber) {
      persistSubscriptionTokenFromUrl(subscriptionNumber);
    }
  }, [subscriptionNumber]);


  useEffect(() => {
    if (appStyleCreatedStore && stepsConfigStore) {
      if (callback === "failure") {
        // setCallbackSRD(success(""));
        // setMessageModal("Merci de reprendre votre parcours de souscription.") // TODO: translate
        // setFormModal(!formModal)
        dispatch(initializeCallback(callback + 'Step', subscriptionNumber));
      } else if (callback === "confirmation" || callback === "cancellation") {
        dispatch(initializeCallback(callback + 'Step', subscriptionNumber));
      }
    }
  }, [callback, appStyleCreatedStore, stepsConfigStore])


  const view = SRD.match({
    notAsked: () => <div></div>,
    // loading: () => <div className="app-loading"><div className="lds-dual-ring" style={{ backgroundColor: 'white', opacity: 0.8, borderRadius: 6 }}></div></div>,
    loading: () => <Backdrop
      open={true}
      style={{
        zIndex: 9999,
        backgroundColor: 'rgba(0, 0, 0, 0.8)'
      }}
    >
      <CircularProgress
        color="primary"
        size={60}
        thickness={4}
      />
    </Backdrop>,
    failure: (e) => <AlertDanger><span>{"Une erreur s'est produite"}</span>{e && <span><br />{e}</span>}</AlertDanger>,
    success: (d) => <div>
      <FormModal modal={formModal} setModal={setFormModal} className={isMobile ? 'modalCls' : 'desktopModalCls'}>
        <div className="amountModalDescription">
          {messageModal}
        </div>
        <Button className="devicesListModalBtn" onClick={() => closeForm()}>Compris</Button>
      </FormModal>
    </div>
  }, onCallbackSRD)

  return view
}
